{
	"common": {
		"loading": "Loading…",
		"loadFailed": "Couldn't load this",
		"tryAgain": "Try again",
		"cancel": "Cancel",
		"close": "Close",
		"done": "Done",
		"back": "Back"
	},
	"tabs": {
		"label": "Accommodation sections",
		"overview": "Overview",
		"rooming": "Rooming",
		"buildings": "Buildings",
		"checkin": "Check-in & out",
		"helpdesk": "Helpdesk",
		"withoutBed_one": "{{n}} person without a bed",
		"withoutBed_other": "{{n}} people without a bed",
		"toCheckIn_one": "{{n}} arrival to check in today",
		"toCheckIn_other": "{{n}} arrivals to check in today",
		"openTickets_one": "{{n}} open ticket",
		"openTickets_other": "{{n}} open tickets"
	},
	"person": {
		"state": {
			"NONE": "No bed",
			"ASSIGNED": "Assigned",
			"IN": "Checked in",
			"OUT": "Checked out"
		},
		"hint": {
			"NONE": "No room assigned yet",
			"ASSIGNED": "Has a room, not checked in",
			"IN": "Checked in at the front desk",
			"OUT": "Checked out"
		},
		"kv": {
			"status": "Status",
			"function": "Function",
			"team": "Team",
			"gender": "Gender",
			"stay": "Stay",
			"room": "Room",
			"flags": "Needs a look"
		},
		"headquarters": "Headquarters",
		"noGender": "Not recorded: a room needs it",
		"notCheckedIn": "Not checked in yet",
		"checkedInAt": "Checked in {{at}}",
		"checkedOutAt": "Checked out {{at}}",
		"assignRoom": "Assign a room",
		"newRoom": "New room",
		"chooseRoom": "Choose a free room",
		"noFreeRoom": "No free room for the whole stay",
		"roomHint": "Rooms reserved for {{org}}, for {{sex}}, free for the whole stay.",
		"roomOption": "{{building}} · {{room}} · {{taken}} of {{beds}} beds taken",
		"assign": "Assign",
		"remove": "Remove from room",
		"move": "Move",
		"moveTitle": "Move {{name}}",
		"changeDates": "Change dates",
		"datesTitle": "Dates for {{name}}",
		"datesHint": "Dates you set here stay fixed when travel changes. The list flags them if they stop matching.",
		"firstNight": "First night",
		"checkOutDay": "Check-out day",
		"saveDates": "Save dates",
		"followTravel": "Follow travel again",
		"checkIn": "Check in",
		"checkOut": "Check out",
		"undoIn": "Undo check-in",
		"undoOut": "Undo check-out",
		"toast": {
			"assigned": "Room assigned",
			"moved": "Moved",
			"removed": "Removed from the room",
			"dates": "Dates saved",
			"follow": "Dates follow travel again",
			"checkedIn": "Checked in",
			"checkedOut": "Checked out",
			"undoIn": "Check-in undone",
			"undoOut": "Check-out undone"
		},
		"openRecord": "Open record"
	},
	"room": {
		"state": {
			"VACANT": "Vacant",
			"RESERVED": "Reserved, empty",
			"PART": "Partly occupied",
			"FULL": "Full",
			"OOS": "Out of service"
		},
		"hint": {
			"VACANT": "Free, not reserved",
			"RESERVED": "Reserved for a contingent, nobody in it yet",
			"PART": "Some beds taken",
			"FULL": "Every bed taken",
			"OOS": "Not usable, for example under repair"
		}
	},
	"flag": {
		"label": {
			"STAY_DIFFERS": "Differs from travel",
			"GENDER_CHANGED": "Gender changed",
			"CARD_WITHDRAWN": "Card withdrawn",
			"LATE_ARRIVAL": "Late arrival",
			"OVERDUE": "Overdue",
			"LATE_CHECKOUT": "Late check-out"
		},
		"hint": {
			"STAY_DIFFERS": "The room's dates no longer match the travel. Change the dates or let them follow travel",
			"GENDER_CHANGED": "The record's gender changed after the room was given. Check the room",
			"CARD_WITHDRAWN": "The card was withdrawn while the person is checked in. Check them out",
			"LATE_ARRIVAL": "Arrives after the front desk closes. The bed is held from the night before",
			"OVERDUE": "The first night has passed and they have not checked in",
			"LATE_CHECKOUT": "Has to leave before the desk opens, or after check-out time"
		}
	},
	"guide": {
		"title": "Room and stay statuses",
		"people": "People",
		"rooms": "Rooms",
		"markers": "Markers",
		"beds": "Bed dots on a room",
		"bed": {
			"free": "Free bed",
			"freeHint": "Nobody in this bed that night",
			"taken": "Taken",
			"takenHint": "Someone has this bed that night, not checked in yet",
			"in": "Checked in",
			"inHint": "Someone is sleeping here, checked in"
		}
	},
	"sex": {
		"MALE": "Man",
		"FEMALE": "Woman",
		"unknown": "Gender not recorded",
		"plural": {
			"MALE": "Men",
			"FEMALE": "Women"
		},
		"letter": {
			"MALE": "M",
			"FEMALE": "W",
			"NONE": "NR"
		}
	},
	"stay": {
		"range": "{{from}} – {{to}}",
		"noDates": "No dates yet: add their departure, or set default dates for the NOC",
		"source": {
			"TRAVEL": "From travel",
			"DEFAULT": "Default dates (no travel yet)",
			"MANUAL": "Dates set by hand"
		}
	},
	"overview": {
		"tonight": "tonight",
		"tiles": {
			"aria": "Accommodation at a glance",
			"label": {
				"beds": "Beds",
				"occupied": "Occupied",
				"inHouse": "In house now",
				"arrivals": "Check-ins",
				"withoutBed": "Without a bed",
				"tickets": "Helpdesk"
			},
			"beds": "Beds",
			"bedsOos_one": "{{n}} bed out of service",
			"bedsOos_other": "{{n}} beds out of service",
			"allInService": "all rooms in service",
			"occupiedOn": "Occupied {{night}}",
			"ofBeds": "{{pct}}% of beds",
			"inHouse": "In house now",
			"checkedIn": "checked in",
			"checkInsToday": "To check in today",
			"checkInsOn": "To check in {{day}}",
			"checkIn": "Check in",
			"allDone": "all done",
			"withoutBed": "Without a bed",
			"assign": "Assign",
			"everyoneHasBed": "everyone has a bed",
			"helpdesk": "Helpdesk",
			"openTickets": "open tickets"
		},
		"occupancy": {
			"title": "Occupancy by night",
			"buildings": "Buildings",
			"line": "{{type}} · {{cluster}} · {{reserved}} of {{beds}} beds reserved",
			"pct": "{{pct}}% occupied",
			"none": "No buildings yet",
			"add": "Add a building"
		}
	},
	"attention": {
		"title": "Needs attention",
		"clear": "All clear",
		"clearHint": "Nothing to do here right now.",
		"view": "View",
		"orgCount": "{{code}} {{n}}",
		"withoutBed": {
			"title_one": "{{n}} person without a bed",
			"title_other": "{{n}} people without a bed",
			"hint_one": "{{n}} contingent: {{list}}. Suggest rooms proposes beds in reserved rooms for you to confirm.",
			"hint_other": "{{n}} contingents: {{list}}. Suggest rooms proposes beds in reserved rooms for you to confirm.",
			"hintPlain": "Suggest rooms proposes beds in reserved rooms for you to confirm.",
			"action": "Assign"
		},
		"short": {
			"title_one": "{{n}} contingent needs more rooms reserved",
			"title_other": "{{n}} contingents need more rooms reserved",
			"hint": "More arriving men or women than reserved beds.",
			"action": "Reserve"
		},
		"overdue": {
			"title_one": "{{n}} guest overdue",
			"title_other": "{{n}} guests overdue",
			"hint": "Their first night has passed and they have not checked in.",
			"action": "Check in"
		},
		"toCheckIn": {
			"title_one": "{{n}} arrival to check in on {{day}}",
			"title_other": "{{n}} arrivals to check in on {{day}}",
			"hint": "Check in a whole group at once when the bus arrives.",
			"action": "Check in"
		},
		"toCheckOut": {
			"title_one": "{{n}} departure to check out on {{day}}",
			"title_other": "{{n}} departures to check out on {{day}}",
			"hint": "Collect key cards before the transfer leaves.",
			"action": "Check out"
		},
		"differs": {
			"title_one": "{{n}} stay set by hand",
			"title_other": "{{n}} stays set by hand",
			"hint": "Dates typed by hand; check they still match the flights."
		},
		"withdrawn": {
			"title_one": "{{n}} withdrawn card still in house",
			"title_other": "{{n}} withdrawn cards still in house",
			"hint": "Check them out and collect the key cards."
		},
		"tickets": {
			"title_one": "{{n}} urgent or high-priority ticket",
			"title_other": "{{n}} urgent or high-priority tickets",
			"hint": "Open helpdesk tickets that affect a room."
		},
		"arrivingNoRoom": {
			"title_one": "{{n}} person arriving {{day}} without a room",
			"title_other": "{{n}} people arriving {{day}} without a room",
			"hint": "Their arrival is on this day and they have no bed yet.",
			"action": "Show them"
		}
	},
	"rooming": {
		"title": "Rooming by contingent",
		"rule": "Rooms are reserved per contingent, one sex per room. Suggestions put teammates together and only use beds free for the whole stay (arrival to departure). Nothing is saved until you confirm.",
		"reserve": "Reserve rooms",
		"autoAll": "Suggest rooms for all ({{n}})",
		"autoOne": "Suggest rooms",
		"gapOk": "OK",
		"shortBoth": "Short {{m}} M, {{f}} F",
		"shortMen": "Short {{m}} M",
		"shortWomen": "Short {{f}} F",
		"split": "{{male}} men, {{female}} women",
		"splitShort": "{{male}} / {{female}}",
		"table": {
			"contingent": "Contingent",
			"people": "People (M / F)",
			"reserved": "Beds reserved (M / F)",
			"gap": "Room gap",
			"withBed": "Have a bed",
			"checkedIn": "Checked in",
			"withoutBed": "Without a bed"
		},
		"empty": {
			"title": "No contingents yet",
			"hint": "Contingents show here once their cards are approved."
		}
	},
	"reserve": {
		"title": "Reserve rooms",
		"sub": "Whole rooms are reserved for one contingent",
		"contingent": "Contingent",
		"chooseContingent": "Choose a contingent",
		"note": "{{name}}: {{men}} men and {{women}} women need a bed (an arrival on record). Reserved {{rm}} men's and {{rf}} women's beds.",
		"noteAny": "{{name}}: {{men}} men and {{women}} women need a bed (an arrival on record). Reserved {{rm}} men's, {{rf}} women's and {{ra}} either-sex beds.",
		"building": "Building",
		"chooseBuilding": "Choose a building",
		"buildingOption": "{{name}} · {{n}} beds free to reserve",
		"bedsMen": "Beds for men",
		"bedsWomen": "Beds for women",
		"womenFirst": "Women's floors are used first.",
		"submit": "Reserve",
		"toast_one": "{{n}} room reserved · {{beds}} beds",
		"toast_other": "{{n}} rooms reserved · {{beds}} beds",
		"errors": {
			"org": "Choose a contingent",
			"building": "Choose a building",
			"number": "Enter whole numbers",
			"beds": "Enter how many beds for men and for women",
			"noneFree": "No free rooms left in {{building}}"
		},
		"partial_one": "Reserved {{rooms}} room ({{beds}} beds) in {{building}}, but it has no more free rooms. Still short: {{men}} beds for men, {{women}} for women. Choose another building for the rest.",
		"partial_other": "Reserved {{rooms}} rooms ({{beds}} beds) in {{building}}, but it has no more free rooms. Still short: {{men}} beds for men, {{women}} for women. Choose another building for the rest."
	},
	"autoAssign": {
		"title_one": "Suggest rooms for {{n}} person",
		"title_other": "Suggest rooms for {{n}} people",
		"rule": "Proposes beds in each contingent's reserved rooms: one sex per room, women first, teammates together, beds free for the whole stay. People without dates or gender are left for later. Nothing is saved until you confirm.",
		"noFallback": "This contingent has no Default dates and the Games have no dates: anyone missing an arrival or a departure will be skipped. Set Default dates first to include them.",
		"confirm_one": "Confirm {{n}} bed",
		"confirm_other": "Confirm {{n}} beds",
		"nothing": "Everyone already has a bed.",
		"doneTitle": "Rooms assigned",
		"assigned": "Assigned",
		"skipped": "Skipped",
		"reasonsTitle": "Not assigned",
		"more": "And {{n}} more",
		"toast_one": "{{n}} person assigned",
		"toast_other": "{{n}} people assigned",
		"reason": {
			"no_gender": "No gender on the record",
			"no_arrival_date": "No arrival date: add their arrival in Arrival & Departure, or set Default dates for the contingent",
			"no_departure_date": "No departure date: add their departure in Arrival & Departure, or set Default dates for the contingent",
			"no_dates": "No arrival or departure date: add their travel in Arrival & Departure, or set Default dates for the contingent",
			"no_reserved_bed": "No reserved bed of their sex free for the whole stay"
		},
		"suggest": "Suggest rooms",
		"reviewTitle_one": "{{n}} bed suggested",
		"reviewTitle_other": "{{n}} beds suggested",
		"reviewHint": "Nothing is saved yet. Untick anyone you want to leave out, update the suggestion, then confirm.",
		"update_one": "Update suggestion ({{n}} left out)",
		"update_other": "Update suggestion ({{n}} left out)",
		"suggestAgain": "Suggest again",
		"changed": "Not saved for {{list}}: beds or travel changed since you reviewed. Suggest again.",
		"noPicks": "No bed to suggest.",
		"where": "{{building}} · Room {{room}} · Bed {{bed}}",
		"nights": "{{from}} → {{to}}",
		"leftOut_one": "{{n}} person left out",
		"leftOut_other": "{{n}} people left out",
		"tooManyOut": "You can leave out at most {{max}} people."
	},
	"contingent": {
		"title": "Contingent",
		"subtitle": "Rooming list",
		"back": "Back to rooming",
		"csv": "Rooming list",
		"csvName": "rooming-{{code}}.csv",
		"defaults": "Default dates",
		"reserve": "Reserve",
		"autoAssign": "Suggest rooms for {{n}}",
		"search": "Name, AC Number or Sport",
		"sort": {
			"name": "Name A–Z",
			"team": "Team",
			"room": "Room"
		},
		"chips": {
			"state": "Status",
			"gender": "Gender",
			"building": "Building",
			"buildingSearch": "Find a building"
		},
		"tiles": {
			"aria": "Contingent rooming at a glance",
			"label": {
				"people": "People",
				"reserved": "Beds reserved",
				"withBed": "Have a bed",
				"in": "Checked in",
				"without": "Without a bed"
			},
			"people": "People",
			"menWomen": "{{m}} men · {{f}} women",
			"reserved": "Beds reserved",
			"mf": "{{m}} M · {{f}} F",
			"short": "Short {{m}} M, {{f}} F",
			"withBed": "Have a bed",
			"checkedIn": "Checked in",
			"withoutBed": "Without a bed",
			"autoOrPick": "suggest rooms or pick one",
			"none": "none"
		},
		"table": {
			"name": "Name",
			"function": "Function",
			"team": "Team",
			"room": "Room",
			"stay": "Stay",
			"status": "Status"
		},
		"bulk": {
			"selected_one": "{{n}} selected",
			"selected_other": "{{n}} selected",
			"counts": "{{in}} to check in · {{out}} to check out",
			"checkIn": "Check in {{n}}",
			"checkOut": "Check out {{n}}",
			"clear": "Clear the selection"
		},
		"pager_one": "Showing {{from}} to {{to}} of {{total}} person",
		"pager_other": "Showing {{from}} to {{to}} of {{total}} people",
		"pagerEmpty": "Nobody to show",
		"empty": {
			"filteredTitle": "Nobody matches",
			"filteredHint": "Try another status, or clear the filters.",
			"clear": "Clear filters",
			"noneTitle": "No approved people yet",
			"noneHint": "People show here once their cards are approved."
		}
	},
	"defaults": {
		"title": "Default dates",
		"rule": "For approved people with no travel yet. Their stay follows these dates until travel is added.",
		"fallback": "Empty: the Games' dates, {{from}} – {{to}}.",
		"noGamesDates": "Empty: the Games' dates, once they are set.",
		"arrive": "First night",
		"depart": "Check-out day",
		"save": "Save dates",
		"clear": "Use the Games' dates",
		"toast": "Default dates saved",
		"toastCleared": "Back to the Games' dates",
		"errors": {
			"order": "The check-out day must be after the first night"
		}
	},
	"check": {
		"titleIn_one": "Check in {{n}} person",
		"titleIn_other": "Check in {{n}} people",
		"titleOut_one": "Check out {{n}} person",
		"titleOut_other": "Check out {{n}} people",
		"noteIn": "Hand out key cards. Their AC card must be ready.",
		"noteOut": "Collect key cards and check the rooms.",
		"in_one": "Check in {{n}}",
		"in_other": "Check in {{n}}",
		"out_one": "Check out {{n}}",
		"out_other": "Check out {{n}}",
		"willSkip_one": "{{n}} will be skipped",
		"willSkip_other": "{{n}} will be skipped",
		"skippedTitle": "Skipped",
		"doneIn": "Checked in",
		"doneOut": "Checked out",
		"checkedIn": "Checked in",
		"checkedOut": "Checked out",
		"skipped": "Skipped",
		"toastIn_one": "{{n}} person checked in",
		"toastIn_other": "{{n}} people checked in",
		"toastOut_one": "{{n}} person checked out",
		"toastOut_other": "{{n}} people checked out",
		"skip": {
			"noBed": "No bed"
		},
		"refusal": {
			"not_found": "Not found, or not yours to check",
			"card_not_ready": "AC card not ready yet",
			"stay_not_started": "Their stay has not started yet",
			"stay_ended": "Their stay has ended",
			"already_in": "Already checked in",
			"not_in": "Not checked in",
			"already_out": "Already checked out",
			"checked_out_first": "Checked out. Undo that first"
		}
	},
	"checkin": {
		"mode": {
			"label": "Show",
			"in": "Check-in",
			"out": "Check-out"
		},
		"scan": "Scan AC card",
		"building": "Building",
		"lineIn_one": "{{n}} person arrives on {{day}} · {{todo}} still to check in. Grouped by arrival, so a whole bus is done in one go.",
		"lineIn_other": "{{n}} people arrive on {{day}} · {{todo}} still to check in. Grouped by arrival, so a whole bus is done in one go.",
		"lineOut_one": "{{n}} person leaves on {{day}} · {{todo}} still to check out. Grouped by departure, so a whole bus is done in one go.",
		"lineOut_other": "{{n}} people leave on {{day}} · {{todo}} still to check out. Grouped by departure, so a whole bus is done in one go.",
		"zoneNote": "Times are {{zone}}",
		"overdue_one": "{{n}} guest from an earlier day has not checked in yet",
		"overdue_other": "{{n}} guests from earlier days have not checked in yet",
		"emptyIn": "Nobody arrives on {{day}}",
		"emptyOut": "Nobody leaves on {{day}}",
		"emptyHint": "Pick another day above.",
		"truncated": "Showing the first groups only. Pick a building to see the rest.",
		"noTravel": "No travel",
		"noService": "No service number",
		"lands": "Lands {{time}}",
		"landsMoved": "Lands {{from}} → {{to}}",
		"departs": "Departs {{time}}",
		"window": "At the hotel {{from}}–{{to}}",
		"outBy": "Check out by {{time}}",
		"moreOrgs": "+{{n}} more",
		"ofTotal": "{{done}} of {{total}}",
		"checkedIn": "checked in",
		"checkedOut": "checked out",
		"people": "People",
		"peopleSub_one": "{{n}} person",
		"peopleSub_other": "{{n}} people",
		"checkInN": "Check in {{n}}",
		"checkOutN": "Check out {{n}}",
		"checkInAll": "Check in",
		"checkOutAll": "Check out",
		"landsAt": "Lands {{time}}",
		"landsHint": "Lands at {{time}}. Check in after arrival",
		"done": "Done",
		"firstOf": "Checking the first {{shown}} of {{n}}. Run it again for the rest."
	},
	"scan": {
		"title": "Scan AC card",
		"sub": "Find a person's room and check them in or out",
		"label": "AC Number",
		"placeholder": "ACC-THA-000123",
		"find": "Find",
		"notFound": "No participant found",
		"notFoundHint": "Check the AC number.",
		"noBed": "No bed yet",
		"roomIn": "{{room}}, {{building}}"
	},
	"building": {
		"title": "Building",
		"back": "Back to buildings",
		"notFound": "Building not found",
		"typeLong": {
			"VILLAGE": "Games Village",
			"HOTEL": "Hotel",
			"OTHER": "Other (apartment, homestay)"
		},
		"tiles": {
			"aria": "Building at a glance",
			"label": {
				"rooms": "Rooms",
				"beds": "Beds",
				"night": "Night",
				"reserved": "Reserved",
				"contact": "Contact"
			},
			"rooms": "Rooms",
			"beds": "Beds",
			"night": "Night of {{night}}",
			"occupied": "{{pct}}% occupied",
			"reserved": "Reserved",
			"forContingents": "beds for contingents",
			"contact": "Contact",
			"tonight": "Tonight"
		},
		"desk": "Desk {{from}}–{{to}}",
		"desk24": "Desk open 24 hours",
		"edit": "Edit building",
		"editFloor": "Edit floor",
		"block": "Block",
		"blockN": "Block {{block}}",
		"floor": "Floor",
		"floorN": "Floor {{floor}}",
		"floorSex": "Floor {{floor}} · {{sex}}",
		"free": "Free",
		"noRooms": "No rooms on this floor",
		"roomsAria": "Rooms on floor {{floor}}",
		"roomAria": "Room {{room}}, {{state}}, {{taken}} of {{beds}} beds",
		"truncated": "This block has more rooms than one map shows. Pick a block above."
	},
	"buildings": {
		"title": "Buildings",
		"count_one": "{{n}} building",
		"count_other": "{{n}} buildings",
		"clusters": "Clusters",
		"add": "Add building",
		"typeCluster": "{{type}} · {{cluster}}",
		"rooms": "Rooms",
		"beds": "Beds",
		"tonight": "Tonight",
		"pct": "{{pct}}%",
		"blocks_one": "{{n}} block",
		"blocks_other": "{{n}} blocks",
		"reservedBeds_one": "{{n}} bed reserved",
		"reservedBeds_other": "{{n}} beds reserved",
		"oos_one": "{{n}} room out of service",
		"oos_other": "{{n}} rooms out of service",
		"inactive": "Inactive",
		"emptyTitle": "No buildings yet",
		"emptyHint": "Add the Games Village and the hotels. Rooms are generated from blocks and floors.",
		"emptyHintReadOnly": "No building is linked to this login yet.",
		"truncated": "Showing the first 200 buildings."
	},
	"buildingForm": {
		"addTitle": "Add building",
		"addSub": "Rooms are generated from the blocks and floors. Edit single rooms later.",
		"editTitle": "Edit building",
		"sections": {
			"building": "Building",
			"desk": "Front desk",
			"rooms": "Rooms",
			"addRooms": "Add rooms"
		},
		"type": "Type",
		"cluster": "Cluster",
		"name": "Lodging name",
		"code": "Building code",
		"codeHint": "Short, e.g. H1 or ATH-V",
		"address": "Address",
		"contactName": "Person in charge",
		"contactPhone": "Their phone",
		"deskHint": "Leave both desk times empty for a 24-hour desk. Late arrivals and \"check out by\" read these.",
		"deskOpens": "Desk opens",
		"deskCloses": "Desk closes",
		"checkOutTime": "Check-out time",
		"blocks": "Blocks",
		"blocksHint": "Separate with commas, e.g. A, B, C. Empty = one block.",
		"addRoomsHint": "Optional. Rooms that already exist are left as they are.",
		"firstFloor": "First floor",
		"topFloor": "Top floor",
		"perFloor": "Rooms per floor",
		"beds": "Beds per room",
		"total_one": "{{rooms}} room, {{beds}} beds will be created.",
		"total_other": "{{rooms}} rooms, {{beds}} beds will be created.",
		"create": "Create building",
		"save": "Save",
		"delete": "Delete",
		"confirmDelete": "Delete this building?",
		"toastCreated_one": "Building created · {{n}} room",
		"toastCreated_other": "Building created · {{n}} rooms",
		"toastAdded_one": "Saved · {{n}} room added ({{skipped}} already there)",
		"toastAdded_other": "Saved · {{n}} rooms added ({{skipped}} already there)",
		"toastSaved": "Building saved",
		"toastDeleted": "Building deleted",
		"roomsFailed": "Building created, but the rooms were not: {{reason}}",
		"errors": {
			"cluster": "Choose a cluster",
			"name": "Enter a name",
			"nameTaken": "A building with this name already exists",
			"address": "Address is required",
			"deskBoth": "Set both desk times, or neither for 24 hours",
			"checkOut": "Enter the check-out time",
			"blocks": "Up to {{max}} blocks: letters, digits or hyphens",
			"floor": "Floors: {{min}} to {{max}}",
			"topFloor": "Top floor must be at or above the first floor",
			"perFloor": "Rooms per floor: 1 to {{max}}",
			"beds": "Beds per room: 1 to {{max}}",
			"tooMany": "At most {{max}} rooms at once",
			"clusterInUse": "People are assigned here. The cluster cannot change",
			"code": "Up to {{max}} letters, numbers or dashes",
			"codeTaken": "Another building already has this code"
		}
	},
	"roomSheet": {
		"title": "Room {{room}}",
		"loading": "Room",
		"reservedFor": "Reserved for",
		"notReserved": "Not reserved",
		"for": "For",
		"forLabel": "Only for",
		"either": "Either (set by the first occupant)",
		"beds": "Beds",
		"bed": "bed {{n}}",
		"oos": "Out of service",
		"occupants": "Occupants",
		"nobody": "Nobody is assigned.",
		"settings": "Room settings",
		"oosToggle": "Out of service (repairs). Left out of assignment",
		"oosNote": "What is wrong",
		"save": "Save",
		"release": "Release reservation",
		"releaseRefused": "Someone is assigned here. Move them first",
		"toastSaved": "Room saved",
		"toastReleased": "Reservation released",
		"errors": {
			"beds": "Beds: 1 to {{max}}"
		},
		"refused": {
			"occupied": "People are staying. Move them first",
			"beds_in_use": "More beds are in use than that",
			"other_sex_staying": "Someone of the other sex is staying",
			"in_use": "This room has been used. Mark it out of service instead"
		},
		"noRestriction": "No restriction"
	},
	"floorEdit": {
		"title": "Floor {{floor}}",
		"titleBlock": "Block {{block}} · Floor {{floor}}",
		"sub": "Change room numbers, beds and who each room is for. Add or remove rooms.",
		"floorNo": "Floor number",
		"allRooms": "All rooms",
		"applyAll": "Apply to all",
		"cols": {
			"number": "Room number",
			"actions": "Actions"
		},
		"removedRow": "Room {{number}} will be removed",
		"undo": "Undo",
		"newRoom": "New room",
		"remove": "Remove room {{number}}",
		"removeOccupied": "People are staying in this room. It is kept and only removed once nobody has ever used it.",
		"empty": "No rooms on this floor. Add one.",
		"addRoom": "Add room",
		"removeHint": "A room that was ever used is kept. Mark it out of service instead.",
		"save": "Save floor",
		"taken": "Already used on another floor: {{numbers}}. Nothing was saved.",
		"done": "Saved: {{created}} added, {{updated}} changed, {{removed}} removed.",
		"skipped": "Not changed:",
		"toast_one": "{{n}} room changed",
		"toast_other": "{{n}} rooms changed",
		"errors": {
			"number": "Enter a room number",
			"numberLong": "At most {{max}} characters",
			"numberTwice": "This number is used twice",
			"numberTaken": "Used on another floor",
			"floor": "Floor: {{min}} to {{max}}",
			"tooMany": "At most {{max}} rooms on a floor",
			"fix": "Fix the marked rooms first"
		}
	},
	"record": {
		"title": "Accommodation",
		"room": "Room",
		"stay": "Stay",
		"status": "Status",
		"flags": "Needs a look",
		"noBed": "No bed yet",
		"openRooming": "Open the rooming list"
	},
	"needsRoom": {
		"title": "Arriving without a room · {{day}}",
		"tabs": "Who to show",
		"tab": {
			"needs_room": "Needs a room",
			"not_approved": "Not approved yet"
		},
		"hint": "People whose arrival is on this day and who have no bed yet. Assign a room, or get suggested rooms for a whole contingent.",
		"hintNotApproved": "Arriving on this day, but their record is not approved yet: no room can be given until it is.",
		"byOrganization": "By contingent",
		"autoAssign": "Suggest rooms",
		"autoAssignHint": "Suggest rooms for everyone in {{org}} without a bed (the whole contingent, not only this day)",
		"autoAssignFor": "Suggest rooms for {{org}}",
		"none": "Everyone arriving on {{day}} has a room",
		"noneNotApproved": "Nobody arriving on {{day}} is waiting for approval",
		"showing": "Showing {{shown}} of {{n}}",
		"loadMore": "Load more",
		"noTime": "No time yet",
		"line": "{{no}} · {{service}} · {{entry}}",
		"firstNight": "Stay",
		"notApproved": "Not approved yet",
		"assign": "Assign room",
		"openRecord": "Open record",
		"journey": "Journey",
		"badge": "Arriving without a room: {{needs}}, {{waiting}}",
		"badgeNeeds_one": "{{n}} needs a room",
		"badgeNeeds_other": "{{n}} need a room",
		"badgeWaiting_one": "{{n}} not approved yet",
		"badgeWaiting_other": "{{n}} not approved yet"
	},
	"calendar": {
		"title": "Arrivals without a room",
		"upcoming": "Coming up",
		"none": "Everyone arriving has a room",
		"needs_one": "{{n}} person without a room",
		"needs_other": "{{n}} people without a room"
	},
	"noRoom": {
		"openRecord": "Open record",
		"gender": {
			"title": "Their gender is not recorded",
			"body": "A room is for men or for women, so the GMS needs to know which. Add their gender on the record, then come back here."
		},
		"reserve": {
			"title": "No rooms reserved for {{org}} ({{sex}}) yet",
			"body": "People only get rooms that are reserved for their NOC. Reserve rooms for {{org}}, for {{sex}} or for anyone, then assign this person."
		},
		"reserveFor": "Reserve rooms for {{org}}",
		"dates": {
			"title": "Their stay has no dates yet",
			"body": "Their nights come from their arrival and departure. Add their departure on the record, or set default stay dates for {{org}}."
		},
		"setDefaults": "Set default dates for {{org}}",
		"full": {
			"title": "Every room reserved for {{org}} ({{sex}}) is full",
			"body": "Each reserved room is taken on at least one night of this person's stay. Reserve more rooms for {{org}}, or free a bed in one of their rooms."
		},
		"reserveMore": "Reserve more rooms"
	}
}
